import { CompactUserResponse } from '../account';
import { CompactGraphResponse } from '../graph/GraphResponse';

export type GraphGroupId = string;

export interface GraphGroupResponse {
  id: GraphGroupId;
  name: string;
  view: GroupViewType;
  users: string[];
  user: CompactUserResponse;
  visibleToAll: boolean;
}

export interface GraphGroupCUResponse {
  id: GraphGroupId;
  name: string;
  view: GroupViewType;
  users: string[];
  user: CompactUserResponse;
  visibleToAll: boolean;
  graphs: CompactGraphResponse[];
}

export enum GroupViewType {
  daily = 'daily',
  weekly = 'weekly',
  monthly = 'monthly',
  quarterly = 'quarterly',
  yearly = 'yearly',
  default = 'default',
}
